import Vue from 'vue'
import Gallery from '@/models/gallery'

export default {
  namespaced: true,

  state: {
    cached: {}
  },

  mutations: {
    SET_ITEMS(state, galleries) {
      galleries.forEach(gallery => {
        gallery = new Gallery(gallery)
        Vue.set(state.cached, gallery.id, gallery)
      })
    }
  },

  getters: {
    items(state) {
      return state.cached
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/galleries.js